export class UserDeletionModel {
  responseQuery() {
    return {
      mutation: {
        deleteMember: {
          redirectUrl: true,
          response: {
            status: true,
            error: true,
            message: true,
            path: true,
            timeStamp: true,
          },
        }
      }
    };
  }
}
